import { Component, inject, Input, OnInit } from '@angular/core';
import { compact } from 'lodash-es';
import { Store } from '@ngrx/store';
import { MenuItem, MenuComponent } from '@rocketfinancialcorp/rocket-ui/menu';
import { ModalService } from '@rocketfinancialcorp/rocket-ui/modal';
import { AuthActions } from '@store';
import { APP_ENV_CONFIG } from '@shared/services';
import { FeatureFlagComponent } from '@shared/components';
import { Employee } from '@shared/models';

@Component({
  selector: 'app-user-header-info',
  templateUrl: './user-header-info.component.html',
  standalone: true,
  imports: [MenuComponent],
})
export class UserHeaderInfoComponent implements OnInit {
  envConfig = inject(APP_ENV_CONFIG);

  store = inject(Store);

  @Input() currentUser!: Employee | null;

  modalService = inject(ModalService);

  @Input() currentUserInitials!: string | null;

  dropdownMenuItems: MenuItem[] = [];

  ngOnInit(): void {
    this.dropdownMenuItems = compact([
      ['develop', 'qa'].includes(this.envConfig.name)
        ? {
            label: 'Feature Management',
            command: () => this.modalService.open(FeatureFlagComponent, { className: 'entity-form-modal' }),
            type: 'link',
          }
        : undefined,
      {
        label: 'Logout',
        command: () => this.store.dispatch(AuthActions.authLogout({})),
        type: 'link',
      },
    ]);
  }
}
